import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { fadeTransition } from '@shared/animations/animations';
import { NgIf, NgClass } from '@angular/common';

@Component({
    selector: 'app-backdrop',
    templateUrl: './backdrop.component.html',
    styleUrls: ['./backdrop.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [fadeTransition],
    imports: [NgIf, NgClass]
})
export class BackdropComponent {
    @Input()
    visible: boolean | undefined = false;

    @Input()
    modalBackdrop: boolean | undefined = false;

    @Output()
    backdropClickEvent: EventEmitter<MouseEvent> = new EventEmitter();
}
